import { Maps } from 'js/components/Maps/index.js';

export class CustomMap extends Maps.GoogleMapsEnterprise {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new CustomMap(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.CustomMap";
  }

  constructor(args) {
    super(args);
    this.pinWidth = 39;
    this.pinHeight = 50;
  }

  svgPin() {
    return `
    <svg width="39px" height="50px" viewBox="0 0 39 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="*Guides/Styles" transform="translate(-1180.000000, -2697.000000)" fill="#0078C8">
          <path d="M1199.5,2697 C1188.775,2697 1180,2705.73524 1180,2716.41165 C1180,2724.82336 1191.7,2739.70562 1196.9,2745.85264 C1198.2,2747.14675 1200.15,2747.47028 1201.45,2746.17617 L1201.775,2745.85264 C1207.3,2739.70562 1219,2724.82336 1219,2716.41165 C1219,2705.73524 1210.225,2697 1199.5,2697 Z M1199.5,2722.88219 C1195.925,2722.88219 1193,2719.97045 1193,2716.41165 C1193,2712.85284 1195.925,2709.9411 1199.5,2709.9411 C1203.075,2709.9411 1206,2712.85284 1206,2716.41165 C1206,2719.97045 1203.075,2722.88219 1199.5,2722.88219 Z" id="Shape"></path>
        </g>
      </g>
    </svg>`;
  }

  setOffsetCenter(latlng) {
    let newCenterLatLng = this.offsetLatLng(latlng, 0, 0);
    this.map.panTo(newCenterLatLng);
  }
}

CustomMap.initClass();
